// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Search Result Style*/
/* Desktop*/
@media only screen and (min-width: 680px) {
  .signal34-contents{
    position:relative;
  }

  .signal34-title {
    display: inline-block;
    text-decoration: none;
    max-width: 100%;
  }

  .signal34-url {
    max-width: 600px;
    width: 100%;
    text-decoration: none;
  }

  .signal34-url a:link, .signal34-url a:visited, .signal34-url a:hover, .signal34-url a:active, .signal34-url span{
    line-height: 1.33;
    cursor: pointer;
    color: var(--signal34UrlTextColor);
    font-size: 14px;
    font-style: normal;
    text-decoration: none;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 50%;
    float: left;
  }
  
  .signal34-menu-score {
    width: 600px;
  }

  .signal34-contents-grid{
    position:relative;
    width: 600px;
    left: 70px;
  }

  .signal34-query-results{
    margin-top: 15px;
    margin-left: 70px;
  }

  .container {
    padding-right: 0px;
    padding-left: 0px;
    padding-top: 10px;
    margin-right: 0px;
    margin-left: 0px;
    position: absolute;
    display: block;
    height: 100%;
  }

  .signal34-last-line {
    display: inline-flex;
    margin-top: 7px;
  }
  
  .signal34-ago {
    color: var(--signal34ContentFooterTextColor); 
  }
  
  .signal34-options-menu {
    padding-left: 16px;
  }

  .signal34-option {
    color: var(--signal34ContentFooterTextColor);  
    padding-left: 8px;
  }
  
  .signal34-option:hover{
    cursor: pointer;
  }

  .signal34-contents-embed{
    position:relative;
    width: 566px;
  }
}
/* for mobile*/
@media only screen and (max-width: 679px) {
  .signal34-content{
    border: solid 1px #E4E4E4;
    box-shadow: 1px 1px 6px 0px #CCCACC;
    -moz-box-shadow: 1px 1px 6px 0px #CCCACC;
    -webkit-box-shadow: 1px 1px 6px 0px #CCCACC;    
    -o-box-shadow: 1px 1px 2px 2px #CCCACC;
    border-radius: 10px;
    padding: 8px;
    padding-bottom: 6px;
    display: -webkit-box;
    margin-bottom: 12px;
    margin-left: 0px;
    margin-right: 0px;
  }

  .signal34-title {
    display: inline-block;
    text-decoration: none;
    width: 100%;
  }

  .signal34-url {
    width: 100%;
    text-decoration: none;
  }

  .signal34-url a:link, .signal34-url a:visited, .signal34-url a:hover, .signal34-url a:active, .signal34-url span {
    line-height: 1.33;
    cursor: pointer;
    color: var(--signal34UrlTextColor);
    font-size: 14px;
    font-style: normal;
    text-decoration: none;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 20%;
    float: left;
  }

  .signal34-menu-score {
    width: 100%;
  }
    
  .signal34-contents-grid{
    position:relative;
  }  

  .signal34-query-results{
    margin-top: 15px;
    margin-left: 10px;
  }
  
  .container {
    padding-right: 0px;
    padding-left: 0px;
    padding-top: 10px;
    position: absolute;
    display: block;
    height: 100%;
    max-width: 100%;
    margin-left: 10px;
    margin-right: 10px;    
  }

  .signal34-last-line {
    margin-top: 7px;  
    display: inline-flex;
    width: 100%;
  }

  .signal34-ago {
    color: var(--signal34ContentFooterTextColor); 
    width: 50%;
  }

  .signal34-options-menu {
    text-align: right;
    width: 50%;
  }

  .signal34-option {
    color: var(--signal34ContentFooterTextColor);
    padding-left: 8px;
  }

  .signal34-option:hover{
    cursor: pointer;
  }

  .signal34-contents-embed{
    position:relative;
    width:100%;
  }
}

.signal34-contents-embed .container {
  padding-right: 0px;
  padding-left: 0px;
  padding-top: 10px;
  position: relative;
  display: block;
  height: 100%;
  max-width: 100%;
  margin-left: 0px;
  margin-right: 0px;
  width: 100%;
}

.signal34-edit-add-content {
  padding-left: 27px;
  position: relative;
  width: 100%;
  display: inline-block;
}

.signal34-title a:link, .signal34-title a:visited, .signal34-title a:hover, .signal34-title a:active, .signal34-title span {
  font-size: 18px;
  line-height: 1.33;
  font-weight: normal;
  margin: 0;
  padding: 0;
  display: block;
  color:var(--signal34TitleTextColor);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  text-decoration: none;
}

.signal34-title a:hover {
  cursor: pointer;
  text-decoration: underline ;
}

.signal34-url a:link, .signal34-url a:visited, .signal34-url a:hover, .signal34-url a:active, .signal34-url span {
  line-height: 1.33;
  cursor: pointer;
  color: var(--signal34UrlTextColor);
  font-size: 14px;
  font-style: normal;
  text-decoration: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 75%;
  float: left;
}

.signal34-score {
  padding-left: 1px;
  position: relative;
  top: -2px;
}

.signal34-tag,
.btn-tag{
  color: var(--signal34TagTextColor);
  border-radius: 4px;
  font-weight: bold;
  padding: 1px 5px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 3px;
  background-color: var(--signal34TagBackgroundColor);
  border: 1px solid transparent;
  border-color: var(--signal34TagBorderColor);
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.signal34-tag:hover,
.btn-tag:hover{
  border-color:var(--signal34TagHoverColor);
}

.signal34-tag:focus,
.signal34-tag:active,
.signal34-tag:active:focus,
.btn-tag:focus,
.btn-tag:active,
.btn-tag:active:focus {
  color: var(--signal34TagFocusActiveColor);
  background-color: var(--signal34TagFocusActiveBackgroundColor);
  border-color: var(--signal34TagFocusActiveBorderColor);
  -webkit-box-shadow: transparent 4px 4px 4px 4px inset;
  box-shadow: transparent 4px 4px 4px 4px inset;
  outline: none;
}

.signal34-tag.btn.btn-outline-secondary.btn-sm:hover {
  color: var(--signal34TagTextColor);
  background-color: var(--signal34TagBackgroundColor);
  border-color: var(--signal34TagHoverColor);
}

.signal34-tags,
.signal34-name{
  padding: 0px;
}

.signal34-tags span {
  margin-right: 5px;
}

.signal34-tags-row{
  display: flex;
}

.signal34-date-notes{
  margin-top: 0px;
  margin-left: 0px;
  margin-right: 0px;
  margin-bottom: 5px;  
  padding: 0px;
}

.signal34-date-notes.col {
  margin-right: 0px;
  margin-left: 0px;
  flex-basis: auto;
}

.signal34-content.row {
  margin-right: 0px;
  margin-left: 0px;  
  display: block;
}

.signal34-edit {
  padding: 0px;
}

.pagination {
  float: right;
  margin: 0;
}

.pagination>.active>a{
  z-index: 1;
}

.signal34-contents-pagination{
  display: inline-block;
  position: relative;
  width: 100%;
  padding-right: 15px;
}

.row {
  margin-right: 0px;
  margin-left: 0px;  
  display: block;
}

.col {
  margin-right: 0px;
  margin-left: 0px;
  padding: 0px;
}

.arrow-drop-down-button {
  margin-top: 4px;
  margin-left: 1px;
  margin-right: 0px;
  left: 0;
  position: relative;
  top: -8px;
}

.arrow-drop-down-button:after {
  position: absolute;
  margin-top: -5px;
  margin-left: 4px;
  margin-right: -5px;
}

.edit-delete-menu.dropdown {
  margin-top: -4px;
  margin-bottom: 6px;
  padding: 0px;
  border:none;
  opacity: 1.0;
  display: contents;
}

.edit-delete-menu.dropdown:hover {
  background: transparent;
  opacity: 1.0;
  cursor: pointer;
}

button#edit-delete-menu-toggle:hover{
  background-color: white;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Contents.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB,WAAW;AACX;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,kCAAkC;IAClC,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,YAAY;EACd;;EAEA;IACE,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,4CAA4C;IAC5C,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,YAAY;EACd;AACF;AACA,cAAc;AACd;EACE;IACE,yBAAyB;IACzB,mCAAmC;IACnC,wCAAwC;IACxC,2CAA2C;IAC3C,sCAAsC;IACtC,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;IACrB,qBAAqB;IACrB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,kCAAkC;IAClC,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,oBAAoB;IACpB,WAAW;EACb;;EAEA;IACE,4CAA4C;IAC5C,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,4CAA4C;IAC5C,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,cAAc;EACd,mCAAmC;EACnC,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;AACX;;AAEA;;EAEE,kCAAkC;EAClC,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mDAAmD;EACnD,6BAA6B;EAC7B,2CAA2C;EAC3C,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;;;;;;EAME,yCAAyC;EACzC,8DAA8D;EAC9D,sDAAsD;EACtD,qDAAqD;EACrD,6CAA6C;EAC7C,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,mDAAmD;EACnD,0CAA0C;AAC5C;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,OAAO;EACP,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":["/* Search Result Style*/\n/* Desktop*/\n@media only screen and (min-width: 680px) {\n  .signal34-contents{\n    position:relative;\n  }\n\n  .signal34-title {\n    display: inline-block;\n    text-decoration: none;\n    max-width: 100%;\n  }\n\n  .signal34-url {\n    max-width: 600px;\n    width: 100%;\n    text-decoration: none;\n  }\n\n  .signal34-url a:link, .signal34-url a:visited, .signal34-url a:hover, .signal34-url a:active, .signal34-url span{\n    line-height: 1.33;\n    cursor: pointer;\n    color: var(--signal34UrlTextColor);\n    font-size: 14px;\n    font-style: normal;\n    text-decoration: none;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 50%;\n    float: left;\n  }\n  \n  .signal34-menu-score {\n    width: 600px;\n  }\n\n  .signal34-contents-grid{\n    position:relative;\n    width: 600px;\n    left: 70px;\n  }\n\n  .signal34-query-results{\n    margin-top: 15px;\n    margin-left: 70px;\n  }\n\n  .container {\n    padding-right: 0px;\n    padding-left: 0px;\n    padding-top: 10px;\n    margin-right: 0px;\n    margin-left: 0px;\n    position: absolute;\n    display: block;\n    height: 100%;\n  }\n\n  .signal34-last-line {\n    display: inline-flex;\n    margin-top: 7px;\n  }\n  \n  .signal34-ago {\n    color: var(--signal34ContentFooterTextColor); \n  }\n  \n  .signal34-options-menu {\n    padding-left: 16px;\n  }\n\n  .signal34-option {\n    color: var(--signal34ContentFooterTextColor);  \n    padding-left: 8px;\n  }\n  \n  .signal34-option:hover{\n    cursor: pointer;\n  }\n\n  .signal34-contents-embed{\n    position:relative;\n    width: 566px;\n  }\n}\n/* for mobile*/\n@media only screen and (max-width: 679px) {\n  .signal34-content{\n    border: solid 1px #E4E4E4;\n    box-shadow: 1px 1px 6px 0px #CCCACC;\n    -moz-box-shadow: 1px 1px 6px 0px #CCCACC;\n    -webkit-box-shadow: 1px 1px 6px 0px #CCCACC;    \n    -o-box-shadow: 1px 1px 2px 2px #CCCACC;\n    border-radius: 10px;\n    padding: 8px;\n    padding-bottom: 6px;\n    display: -webkit-box;\n    margin-bottom: 12px;\n    margin-left: 0px;\n    margin-right: 0px;\n  }\n\n  .signal34-title {\n    display: inline-block;\n    text-decoration: none;\n    width: 100%;\n  }\n\n  .signal34-url {\n    width: 100%;\n    text-decoration: none;\n  }\n\n  .signal34-url a:link, .signal34-url a:visited, .signal34-url a:hover, .signal34-url a:active, .signal34-url span {\n    line-height: 1.33;\n    cursor: pointer;\n    color: var(--signal34UrlTextColor);\n    font-size: 14px;\n    font-style: normal;\n    text-decoration: none;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 20%;\n    float: left;\n  }\n\n  .signal34-menu-score {\n    width: 100%;\n  }\n    \n  .signal34-contents-grid{\n    position:relative;\n  }  \n\n  .signal34-query-results{\n    margin-top: 15px;\n    margin-left: 10px;\n  }\n  \n  .container {\n    padding-right: 0px;\n    padding-left: 0px;\n    padding-top: 10px;\n    position: absolute;\n    display: block;\n    height: 100%;\n    max-width: 100%;\n    margin-left: 10px;\n    margin-right: 10px;    \n  }\n\n  .signal34-last-line {\n    margin-top: 7px;  \n    display: inline-flex;\n    width: 100%;\n  }\n\n  .signal34-ago {\n    color: var(--signal34ContentFooterTextColor); \n    width: 50%;\n  }\n\n  .signal34-options-menu {\n    text-align: right;\n    width: 50%;\n  }\n\n  .signal34-option {\n    color: var(--signal34ContentFooterTextColor);\n    padding-left: 8px;\n  }\n\n  .signal34-option:hover{\n    cursor: pointer;\n  }\n\n  .signal34-contents-embed{\n    position:relative;\n    width:100%;\n  }\n}\n\n.signal34-contents-embed .container {\n  padding-right: 0px;\n  padding-left: 0px;\n  padding-top: 10px;\n  position: relative;\n  display: block;\n  height: 100%;\n  max-width: 100%;\n  margin-left: 0px;\n  margin-right: 0px;\n  width: 100%;\n}\n\n.signal34-edit-add-content {\n  padding-left: 27px;\n  position: relative;\n  width: 100%;\n  display: inline-block;\n}\n\n.signal34-title a:link, .signal34-title a:visited, .signal34-title a:hover, .signal34-title a:active, .signal34-title span {\n  font-size: 18px;\n  line-height: 1.33;\n  font-weight: normal;\n  margin: 0;\n  padding: 0;\n  display: block;\n  color:var(--signal34TitleTextColor);\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  text-decoration: none;\n}\n\n.signal34-title a:hover {\n  cursor: pointer;\n  text-decoration: underline ;\n}\n\n.signal34-url a:link, .signal34-url a:visited, .signal34-url a:hover, .signal34-url a:active, .signal34-url span {\n  line-height: 1.33;\n  cursor: pointer;\n  color: var(--signal34UrlTextColor);\n  font-size: 14px;\n  font-style: normal;\n  text-decoration: none;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 75%;\n  float: left;\n}\n\n.signal34-score {\n  padding-left: 1px;\n  position: relative;\n  top: -2px;\n}\n\n.signal34-tag,\n.btn-tag{\n  color: var(--signal34TagTextColor);\n  border-radius: 4px;\n  font-weight: bold;\n  padding: 1px 5px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 3px;\n  background-color: var(--signal34TagBackgroundColor);\n  border: 1px solid transparent;\n  border-color: var(--signal34TagBorderColor);\n  max-width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.signal34-tag:hover,\n.btn-tag:hover{\n  border-color:var(--signal34TagHoverColor);\n}\n\n.signal34-tag:focus,\n.signal34-tag:active,\n.signal34-tag:active:focus,\n.btn-tag:focus,\n.btn-tag:active,\n.btn-tag:active:focus {\n  color: var(--signal34TagFocusActiveColor);\n  background-color: var(--signal34TagFocusActiveBackgroundColor);\n  border-color: var(--signal34TagFocusActiveBorderColor);\n  -webkit-box-shadow: transparent 4px 4px 4px 4px inset;\n  box-shadow: transparent 4px 4px 4px 4px inset;\n  outline: none;\n}\n\n.signal34-tag.btn.btn-outline-secondary.btn-sm:hover {\n  color: var(--signal34TagTextColor);\n  background-color: var(--signal34TagBackgroundColor);\n  border-color: var(--signal34TagHoverColor);\n}\n\n.signal34-tags,\n.signal34-name{\n  padding: 0px;\n}\n\n.signal34-tags span {\n  margin-right: 5px;\n}\n\n.signal34-tags-row{\n  display: flex;\n}\n\n.signal34-date-notes{\n  margin-top: 0px;\n  margin-left: 0px;\n  margin-right: 0px;\n  margin-bottom: 5px;  \n  padding: 0px;\n}\n\n.signal34-date-notes.col {\n  margin-right: 0px;\n  margin-left: 0px;\n  flex-basis: auto;\n}\n\n.signal34-content.row {\n  margin-right: 0px;\n  margin-left: 0px;  \n  display: block;\n}\n\n.signal34-edit {\n  padding: 0px;\n}\n\n.pagination {\n  float: right;\n  margin: 0;\n}\n\n.pagination>.active>a{\n  z-index: 1;\n}\n\n.signal34-contents-pagination{\n  display: inline-block;\n  position: relative;\n  width: 100%;\n  padding-right: 15px;\n}\n\n.row {\n  margin-right: 0px;\n  margin-left: 0px;  \n  display: block;\n}\n\n.col {\n  margin-right: 0px;\n  margin-left: 0px;\n  padding: 0px;\n}\n\n.arrow-drop-down-button {\n  margin-top: 4px;\n  margin-left: 1px;\n  margin-right: 0px;\n  left: 0;\n  position: relative;\n  top: -8px;\n}\n\n.arrow-drop-down-button:after {\n  position: absolute;\n  margin-top: -5px;\n  margin-left: 4px;\n  margin-right: -5px;\n}\n\n.edit-delete-menu.dropdown {\n  margin-top: -4px;\n  margin-bottom: 6px;\n  padding: 0px;\n  border:none;\n  opacity: 1.0;\n  display: contents;\n}\n\n.edit-delete-menu.dropdown:hover {\n  background: transparent;\n  opacity: 1.0;\n  cursor: pointer;\n}\n\nbutton#edit-delete-menu-toggle:hover{\n  background-color: white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
